import { Injectable } from '@angular/core';
import { BehaviorSubject, Subscription, ReplaySubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class StateService {

  isCallOngoing = new BehaviorSubject<boolean>(false);
  dateChanged$ = new ReplaySubject<boolean>();

  constructor() {
    this.dateChanged$.next(false);
  }

  setTelehealthCallStatus(status: boolean) {
    this.isCallOngoing.next(status);
  }

  isTelehealthCallOngoing(): boolean {
    return this.isCallOngoing.value;
  }

}
